/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    'use strict';

    export class MeevoMessengerDeletedConversation implements angular.IDirective {
        restrict = 'E';
        scope = {
            conversation: '=',
            isSelected: '=',
            type: '='
        };

        templateUrl = 'app/plugins/meevoMessenger/directives/deletedConversation/deletedConversation.html';


        constructor(protected appSettings: Meevo.Components.Common.IAppSettings) { }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            const updateUserInfo = () => {
                scope.elementClass = `deleted-conversation__${scope.type === DeletedConversationStylesEnum.Client ? 'client' : 'employee'}`;
                scope.elementSelectedClass = `${scope.elementClass}--selected`;
                scope.displayInfo = scope.type === DeletedConversationStylesEnum.Client ? scope.getClientDisplayInfo(scope.conversation) : scope.getEmployeeDisplayInfo(scope.conversation);
            };

            scope.getClientDisplayInfo = (conversation: MeevoMessengerConversation): string => {
                const displayName = conversation.displayName;

                if (displayName) return `${displayName}`;

                return Meevo.Plugins.MeevoMessenger.Constants.DEFAULT_USER_NAME;
            };

            scope.getEmployeeDisplayInfo = (conversation: MeevoMessengerConversation): string => {
                const displayName = conversation.displayName ? conversation.displayName : Meevo.Plugins.MeevoMessenger.Constants.DEFAULT_USER_NAME;
                const code = conversation.employeeCode ? conversation.employeeCode : Meevo.Plugins.MeevoMessenger.Constants.DEFAULT_USER_NAME;

                return `${code}: ${displayName}`;
            };

            // trigger to re-render this directive after second search, due to md-virtual-repeat cashing bug
            scope.$watch('conversation', function(oldValue, newValue) {
                if (newValue) {
                    updateUserInfo();
                }
            });

            updateUserInfo();
        };

        static factory(): angular.IDirectiveFactory {
            let directive = (appSettings) => {
                return new MeevoMessengerDeletedConversation(appSettings);
            };

            directive.$inject = [
                'meevo.AppSettings'
            ];

            return directive;
        }
    }

    angular.module('meevo.plugins.meevoMessenger')
        .directive('meevoMessengerDeletedConversation', MeevoMessengerDeletedConversation.factory());
}
